import React, { useState, useEffect } from "react";
import { Alert } from "reactstrap";
import GameMap from "../Maps/logic/GameMap";
import { mapConfigs } from "../Maps/MapConfig/mapConfigs";
import "./MyIslandWidget.css";

const MyIslandWidget = () => {
  const [islandStatus, setIslandStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch island status on component mount
  useEffect(() => {
    const fetchIslandStatus = async () => {
      try {
        // You can add an API call here to check island availability/cooldown
        // For now, we'll assume it's always available
        setIslandStatus({
          available: true,
          cooldown: null,
          lastVisit: null
        });
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch island status:", err);
        setError("Unable to load island status");
        setLoading(false);
      }
    };

    fetchIslandStatus();
  }, []);

  if (loading) {
    return (
      <div className="mb-4">
        <h5 style={{ 
          color: "var(--content-text-primary)", 
          fontWeight: "600",
          marginBottom: "1rem",
          paddingLeft: "0.5rem",
          borderLeft: "3px solid var(--theme-accent)",
          transition: "all 0.3s ease"
        }}>My Island</h5>
        <div style={{ 
          color: "var(--content-text-secondary)",
          backgroundColor: "var(--content-card-bg)",
          borderRadius: "8px",
          padding: "1.5rem",
          textAlign: "center",
          border: "1px solid var(--content-card-border)",
          transition: "all 0.3s ease"
        }}>
          <div className="spinner-border text-primary" role="status" style={{ width: "2rem", height: "2rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 mb-0">Loading My Island...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mb-4">
        <h5 style={{ 
          color: "var(--content-text-primary)", 
          fontWeight: "600",
          marginBottom: "1rem",
          paddingLeft: "0.5rem",
          borderLeft: "3px solid var(--theme-accent)",
          transition: "all 0.3s ease"
        }}>My Island</h5>
        <Alert color="warning">
          <h6>My Island Unavailable</h6>
          <small>{error}</small>
        </Alert>
      </div>
    );
  }

  if (!islandStatus?.available) {
    return (
      <div className="mb-4">
        <h5 style={{ 
          color: "var(--content-text-primary)", 
          fontWeight: "600",
          marginBottom: "1rem",
          paddingLeft: "0.5rem",
          borderLeft: "3px solid var(--theme-accent)",
          transition: "all 0.3s ease"
        }}>My Island</h5>
        <Alert color="info">
          <h6>My Island On Cooldown</h6>
          <small>Your island is currently unavailable. Please try again later.</small>
        </Alert>
      </div>
    );
  }

  return (
    <div className="my-island-widget">
      <h5 style={{ 
        color: "var(--content-text-primary)", 
        fontWeight: "600",
        marginBottom: "1rem",
        paddingLeft: "0.5rem",
        borderLeft: "3px solid var(--theme-accent)",
        transition: "all 0.3s ease"
      }}>My Island</h5>
      
      <GameMap config={mapConfigs.myisland} />
    </div>
  );
};

export default MyIslandWidget;
